import { useLazyQuery } from '@apollo/client';
import { Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { GET_APPLICATION_LOGS } from '../../../graphql/queries/cacClient';
import { fDateTime } from '../../../utils/formatTime';

const CacActivityLog = ({ applicationId, expanded }) => {
  const [getApplicationLogs, { loading, data }] = useLazyQuery(GET_APPLICATION_LOGS);

  useEffect(() => {
    if (expanded && applicationId) {
      getApplicationLogs({ variables: { applicationId } });
    }
  }, [expanded, applicationId, getApplicationLogs]);

  if (!expanded) return null;

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ py: 2 }}>
        <CircularProgress />
      </Grid>
    );
  }

  const logs = data?.getApplicationLogs || [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Activity Log
        </Typography>
      </Grid>
      {logs.map((log) => (
        <Grid item xs={12} key={log._id}>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" color="primary">
                    {log.activityType}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" color="text.secondary">
                    {log.description}
                  </Typography>
                </Grid>
                {log.metadata && Object.keys(log.metadata).length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
                      Changes:
                    </Typography>
                    {Object.entries(log.metadata).map(([key, value]) => (
                      <Typography key={key} variant="body2" color="text.secondary" sx={{ pl: 2 }}>
                        {key}: {typeof value === 'object' ? JSON.stringify(value) : value}
                      </Typography>
                    ))}
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    By: {log.performedBy.firstName} {log.performedBy.lastName} ({log.performedBy.email})
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary">
                    {fDateTime(log.timestamp)}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CacActivityLog; 